import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["data-tour"]
const _hoisted_2 = { class: "truncate" }
const _hoisted_3 = {
  key: 0,
  class: "ml-auto h-3.5 w-3.5 shrink-0 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  role: "img",
  "aria-label": "Locked"
}
const _hoisted_4 = {
  key: 2,
  class: "ml-2 bg-yellow-300 text-gray-900 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full"
}
const _hoisted_5 = ["data-tour"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["data-tour"]
const _hoisted_9 = { class: "truncate" }
const _hoisted_10 = {
  key: 0,
  class: "ml-auto h-3.5 w-3.5 shrink-0 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  role: "img",
  "aria-label": "Locked"
}
const _hoisted_11 = ["data-tour"]
const _hoisted_12 = { class: "truncate" }
const _hoisted_13 = {
  key: 0,
  "data-nav-badge": "",
  class: "flex-shrink-0 text-[11px] font-semibold text-amber-200"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

import { ChevronRightIcon } from '@heroicons/vue/20/solid'
import { computed, ref, watch } from 'vue'

import { NAV_LINK_ACTIVE as ACTIVE_LINK, NAV_LINK_IDLE as IDLE_LINK } from '@/config/nav/linkClasses'
import { navItemTarget, navTourTarget } from '@/config/tours'

const LIST_TOGGLE =
  'block w-full truncate rounded-md px-2 py-1 text-left text-sm tracking-tight text-gray-500 hover:bg-gray-800 hover:text-gray-200'


export default {
  __name: 'AppNavItem',
  props: {
  section: { type: Object, required: true },
  highlighted: { type: Boolean, default: false },
  unreadCount: { type: Number, default: 0 },
  children: { type: Array, default: () => [] },
  open: { type: Boolean, default: false },
  isChildActive: { type: Function, default: () => false }
},
  emits: ['toggle', 'show-more', 'show-fewer'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const openChild = ref(null)
let settled = false

const parentOfCurrentPage = computed(
  () => props.children.find(child => child.children?.length && props.isChildActive(child))?.name ?? null
)

watch(
  parentOfCurrentPage,
  name => {
    if (settled || !name) return
    openChild.value = name
    settled = true
  },
  { immediate: true }
)

watch(
  () => props.open,
  (isOpen, wasOpen) => {
    if (!isOpen || wasOpen) return
    settled = true
    openChild.value = null
  }
)

const toggleChild = name => {
  settled = true
  openChild.value = openChild.value === name ? null : name
}

const showsNestedPage = child => child.children?.some(props.isChildActive)

const childRowClass = child => {
  if (!props.isChildActive(child)) return IDLE_LINK
  if (showsNestedPage(child)) return 'font-semibold text-gray-100 hover:bg-gray-800'
  return ACTIVE_LINK
}

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", {
    "data-tour": _unref(navTourTarget)(__props.section.route)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        __props.highlighted
          ? 'bg-gray-700 text-gray-200 font-semibold'
          : 'text-gray-300 hover:bg-gray-600 hover:text-gray-200 font-medium',
        'transition-all group flex items-center justify-between text-sm rounded-md'
      ])
    }, [
      (__props.section.route)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.children.length ? 'button' : 'router-link'), _mergeProps({ key: 0 }, __props.children.length ? { type: 'button', 'aria-expanded': __props.open } : { to: __props.section.route }, {
            class: "flex w-full items-center px-2 py-1.5 min-w-0 text-left",
            onClick: _cache[0] || (_cache[0] = $event => (__props.children.length && ($event.stopPropagation(), emit('toggle'))))
          }), {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(__props.section.icon), {
                class: "text-gray-400 group-hover:text-gray-300 mr-3 h-4 w-4 shrink-0",
                "aria-hidden": "true"
              })),
              _createElementVNode("span", _hoisted_2, _toDisplayString(__props.section.name), 1),
              (__props.section.locked)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                    }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (__props.section.type === 'messages' && __props.unreadCount)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["bg-red-500 h-5 rounded-full text-center ml-2", { 'w-5': __props.unreadCount <= 9, 'px-1': __props.unreadCount > 9 }])
                  }, _toDisplayString(__props.unreadCount), 3))
                : _createCommentVNode("", true),
              (__props.section.type === 'ai')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " New "))
                : _createCommentVNode("", true),
              (__props.children.length)
                ? (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
                    key: 3,
                    class: _normalizeClass(["ml-auto h-4 w-4 shrink-0 text-gray-400 transition-transform duration-150", __props.open && 'rotate-90']),
                    "aria-hidden": "true"
                  }, null, 8, ["class"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 16))
        : _createCommentVNode("", true)
    ], 2),
    (__props.children.length && __props.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "data-tour": _unref(navTourTarget)(__props.section.route, 'items'),
          class: "ml-4 mt-1 space-y-0.5 border-l border-gray-700 pl-2",
          role: "group"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.children, (child) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: child.link ?? child.toggle ?? child.name
            }, [
              (child.toggle)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(LIST_TOGGLE),
                    onClick: _withModifiers($event => (emit(child.toggle === 'more' ? 'show-more' : 'show-fewer', child.list)), ["stop"])
                  }, _toDisplayString(child.toggle === 'more' ? `Show ${child.count} more` : 'Show fewer'), 9, _hoisted_6))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", {
                      "data-tour": _unref(navItemTarget)(child.link ?? child.name),
                      class: _normalizeClass(["flex items-center rounded-md text-sm tracking-tight transition-colors", [childRowClass(child), child.inactive && 'opacity-60']])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(child.children?.length ? 'button' : 'router-link'), _mergeProps({ ref_for: true }, 
                child.children?.length
                  ? { type: 'button', 'aria-expanded': openChild.value === child.name }
                  : { to: child.link }
              , {
                        class: "flex w-full min-w-0 items-center justify-between gap-2 px-2 py-1 text-left",
                        onClick: $event => (child.children?.length && ($event.stopPropagation(), toggleChild(child.name)))
                      }), {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(child.name), 1),
                          (child.locked)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d: "M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                                }, null, -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (child.children?.length)
                            ? (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
                                key: 1,
                                class: _normalizeClass(["h-3.5 w-3.5 shrink-0 text-gray-500 transition-transform duration-150", openChild.value === child.name && 'rotate-90']),
                                "aria-hidden": "true"
                              }, null, 8, ["class"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1040, ["onClick"]))
                    ], 10, _hoisted_8),
                    (child.children?.length && openChild.value === child.name)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          "data-tour": _unref(navItemTarget)(child.link ?? child.name, 'items'),
                          class: "ml-3 mt-0.5 space-y-0.5 border-l border-gray-700 pl-2",
                          role: "group"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (grandchild) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              key: grandchild.link,
                              to: grandchild.link,
                              class: _normalizeClass(["flex items-center justify-between gap-2 rounded-md px-2 py-1 text-sm tracking-tight transition-colors", __props.isChildActive(grandchild) ? _unref(ACTIVE_LINK) : _unref(IDLE_LINK)])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(grandchild.name), 1),
                                (grandchild.badge)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(grandchild.badge), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["to", "class"]))
                          }), 128)),
                          (child.hiddenCount)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: _normalizeClass(LIST_TOGGLE),
                                onClick: _withModifiers($event => (emit('show-more', child.name)), ["stop"])
                              }, " Show " + _toDisplayString(child.hiddenCount) + " more ", 9, _hoisted_14))
                            : _createCommentVNode("", true),
                          (child.canShowFewer)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: _normalizeClass(LIST_TOGGLE),
                                onClick: _withModifiers($event => (emit('show-fewer', child.name)), ["stop"])
                              }, " Show fewer ", 8, _hoisted_15))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]))
            ], 64))
          }), 128))
        ], 8, _hoisted_5))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

}